import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import EleveService from '../../services/EleveService';
import SalledeclasseService from '../../services/SalledeclasseService';
import BulletinnoteService from '../../services/BulletinnoteService';
import PersonnelService from '../../services/PersonnelService';
import CompetenceService from '../../services/CompetenceService';
import MatiereService from '../../services/MatiereService';
import Filigrane from '../../../../assets/images/brand/logo/logo-filigrane.svg';
import { Col, Image, Row } from 'react-bootstrap';
import Logo from '../../../../assets/images/brand/logo/logo-entete.svg';
import { Avatar } from '../../../elements/bootstrap/Avatar';
import BulletinCompetenceTable from './BulletinCompetenceTable';
import BulletinMatiereTable from './BulletinMatiereTable';

const PrintInvoiceDetailsBulletinnote = React.forwardRef((props, ref) => {
	// Décomposition pour accéder plus facilement aux props
	const { selectedYear, selectedTrimester } = props;
	const { salledeclasseId, eleveId } = useParams();
	const [eleve, setEleve] = useState(null);
	const [enseignantTitulaire, setEnseignantTitulaire] = useState(null);
	const [countEleve, setCountEleve] = useState(null);
	const [salledeclasse, setSalledeclasse] = useState(null);
	const [bulletin, setBulletin] = useState([]);
	const [competences, setCompetences] = useState([]);
	const [matieres, setMatieres] = useState([]);

	useEffect(() => {
		async function fetchInitialData() {
			try {
				const [
					eleveData,
					allBulletinsAnnuel,
					salledeclasseData,
					competencesData,
					matieresData,
					bulletinData
				] = await Promise.all([
					EleveService.getEleve(eleveId),
					BulletinnoteService.getBulletinAnnuel(
						salledeclasseId,
						null,
						selectedYear.id
					),
					SalledeclasseService.getSalledeclasse(salledeclasseId),
					CompetenceService.getAllCompetences(salledeclasseId, selectedYear.id),
					MatiereService.getAllMatieres(salledeclasseId, selectedYear.id),
					BulletinnoteService.getBulletinTrimestriel(
						salledeclasseId,
						eleveId,
						selectedTrimester,
						selectedYear.id
					)
				]);

				setEleve(eleveData.data);
				setCountEleve(allBulletinsAnnuel);
				setSalledeclasse(salledeclasseData.data);
				setCompetences(competencesData);
				setMatieres(matieresData);
				setBulletin(bulletinData);
			} catch (error) {
				console.error('Erreur lors de la récupération des données:', error);
				alert(
					`Erreur lors de la récupération des données. Détails de l'erreur : ${error.message}`
				);
			}
		}

		fetchInitialData().catch((error) => {
			console.error('Unhandled error during initial data fetch:', error);
		});
	}, [eleveId, salledeclasseId, selectedYear, selectedTrimester, bulletin]);

	useEffect(() => {
		async function fetchEnseignant() {
			if (salledeclasse && salledeclasse.personnel) {
				try {
					const enseignantData = await PersonnelService.getPersonnel(
						Number(salledeclasse.personnel)
					);
					setEnseignantTitulaire(enseignantData.data);
				} catch (error) {
					console.error('Error fetching enseignant data:', error);
				}
			}
		}

		fetchEnseignant().catch((error) => {
			console.error('Unhandled error in fetchEnseignant:', error);
		});
	}, [salledeclasse]);

	useEffect(() => {
		setEleve(null);
		setEnseignantTitulaire(null);
		setCountEleve(null);
		setSalledeclasse(null);
		setBulletin([]);
		setCompetences([]);
		setMatieres([]);
	}, [selectedYear, selectedTrimester]);

	function formatDate(dateString) {
		const [year, month, day] = dateString.split('-');
		return `${day}/${month}/${year}`;
	}

	function formatIntituleClasse(value) {
		return value.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
	}

	const scale = 0.9;

	return (
		<div
			ref={ref}
			style={{
				background: `url(${Filigrane}) repeat-y top center`,
				backgroundSize: 'contain',
				transform: `scale(${scale})`, // minHeight: '1500px',
				minHeight: '841.92px',
				transformOrigin: 'top',
				boxSizing: 'border-box'
			}}
			className="d-flex flex-column text-black justify-content-between w-100"
		>
			{eleve && salledeclasse && selectedYear ? (
				<>
					{/* Header */}
					<Row className="text-center small">
						<Col>
							<b>
								{salledeclasse.section === 'fr'
									? 'GROUPE SCOLAIRE BILINGUE PRIVE LA FFEM'
									: 'BILINGUAL AND PRIMARY SCHOOL FFEM'}
							</b>
							<br />
							<b>NGONA</b>
							<br />
							<b>
								{salledeclasse.section === 'fr' ? 'Téléphone:' : 'Phone:'}{' '}
							</b>{' '}
							698 11 79 43 / 675 51 88 55
							<br /> 699 90 93 21 / 691 77 45 65
							<br />
							<b>
								{salledeclasse.section === 'fr' ? 'Email:' : 'Email:'}{' '}
							</b>{' '}
							FFEM@gmail.com
							<br />
						</Col>

						<Col>
							<Image src={Logo} alt="" width="40%" className="mb-4" />
						</Col>
						<Col>
							<b>
								{salledeclasse.section === 'fr'
									? "MINISTERE DE L'EDUCATION DE BASE"
									: 'MINISTRY OF BASIC EDUCATION'}
							</b>
							<br />
							<b>
								{salledeclasse.section === 'fr'
									? 'DELEGATION REGIONALE DU CENTRE'
									: 'CENTRAL REGIONAL DELEGATION'}
							</b>
							<br />
							<b>
								{salledeclasse.section === 'fr'
									? 'DELEGATION DEPARTEMENTALE'
									: 'DIVISIONAL DELEGATION'}
							</b>
							<br />
							<b>
								{salledeclasse.section === 'fr'
									? 'DE MEFOU ET AFAMBA'
									: 'FOR MEFOU ET AFAMBA'}
							</b>
							<br />
						</Col>
					</Row>
					<Row className="text-center mb-4">
						<Col>
							<div>
								<span>
									{salledeclasse.section === 'fr'
										? "Autorisation d'ouverture N°082/J1/23/A/MINEDUB/SG/DSEPB/SDAAP du 03 Août 2022"
										: 'Authorization No. 082/J1/23/A/MINEDUB/SG/DSEPB/SDAAP of August 03, 2022'}
								</span>
							</div>
							<div
								className="py-2 h3 text-center text-uppercase text-dark fw-bold"
								style={{ backgroundColor: '#b1b1b1' }}
							>
								<span>
									{salledeclasse.section === 'fr'
										? `BULLETIN DE NOTES TRIMESTRIEL N°${selectedTrimester}`
										: `TRIMESTER PROGRESS REPORT CARD N°${selectedTrimester}`}
								</span>
							</div>
						</Col>
					</Row>

					<Row className="mb-2 small">
						{/* 1ère colonne : Image de l'élève */}
						<Col className="text-center">
							{eleve.photo ? (
								<Avatar
									type="image"
									src={eleve.photo}
									className="img-thumbnail"
									size="xxl"
								/>
							) : null}
						</Col>

						{/* 2e colonne : Informations de l'élève */}
						<Col>
							<p>
								<b>
									{salledeclasse.section === 'fr'
										? 'Nom et Prénom :'
										: "Learner's name :"}{' '}
								</b>
								<span className="text-uppercase">
									{eleve.nom} {eleve.prenom}
								</span>
							</p>
							<p>
								<b>
									{salledeclasse.section === 'fr'
										? 'Date de naissance :'
										: 'Date of Birth :'}{' '}
								</b>
								{formatDate(eleve.date_naissance)}
							</p>
							<p>
								<b>
									{salledeclasse.section === 'fr'
										? 'Lieu de naissance :'
										: 'Place of Birth :'}{' '}
								</b>
								<span className="text-capitalize">{eleve.lieu_naissance}</span>
							</p>
							<p>
								<b>
									{salledeclasse.section === 'fr'
										? 'Matricule :'
										: 'Reg. Number :'}{' '}
								</b>
								<span className="text-uppercase">{eleve.matricule}</span>
							</p>
						</Col>

						{/* 3e colonne : Détails de la salle de classe */}
						<Col>
							<p>
								<b>
									{salledeclasse.section === 'fr'
										? 'Salle de classe :'
										: 'Class :'}{' '}
								</b>
								<span className="text-uppercase">
									{salledeclasse
										? formatIntituleClasse(
												salledeclasse.intitule_classe
										  ).toUpperCase()
										: ''}
								</span>
							</p>
							<p>
								<b>
									{salledeclasse.section === 'fr'
										? 'Effectif :'
										: 'Enrollment :'}{' '}
								</b>
								{countEleve.length}
							</p>
							<p>
								<b>
									{salledeclasse.section === 'fr'
										? 'Redoublé ? :'
										: 'Repeater ? :'}{' '}
								</b>
								{eleve.classe_redoublement
									? salledeclasse.section === 'fr'
										? 'Oui'
										: 'Yes'
									: salledeclasse.section === 'fr'
									? 'Non'
									: 'No'}
							</p>
						</Col>

						{/* 4e colonne : Détails de l'année scolaire */}
						<Col>
							<p>
								<b>
									{salledeclasse.section === 'fr'
										? 'Année scolaire :'
										: 'Academic Year :'}{' '}
								</b>
								{selectedYear.annee_debut} - {selectedYear.annee_fin}
							</p>
							<p>
								<b>
									{salledeclasse.section === 'fr'
										? 'Enseignant titulaire :'
										: "Facilitator's Name :"}{' '}
								</b>
								{salledeclasse.personnel && enseignantTitulaire ? (
									<span className="text-uppercase">
										{' '}
										{enseignantTitulaire.nom} {enseignantTitulaire.prenom}
									</span>
								) : null}
							</p>
						</Col>
					</Row>

					<Row className="mb-auto small">
						<Col>
							{selectedYear.id <= 2 ? (
								['class_six', 'cm2'].includes(salledeclasse.intitule_classe) ? (
									<BulletinMatiereTable
										bulletin={bulletin}
										matieres={matieres}
									/>
								) : (
									<BulletinCompetenceTable
										bulletin={bulletin}
										competences={competences}
									/>
								)
							) : [
									'class_four',
									'class_five',
									'class_six',
									'ce2',
									'cm1',
									'cm2'
							  ].includes(salledeclasse.intitule_classe) ? (
								<BulletinMatiereTable bulletin={bulletin} matieres={matieres} />
							) : (
								<BulletinCompetenceTable
									bulletin={bulletin}
									competences={competences}
								/>
							)}
						</Col>
					</Row>
				</>
			) : (
				<div>
					Chargement des données de l'élève pour le bulletin trimestriel...
				</div>
			)}
		</div>
	);
});
export default PrintInvoiceDetailsBulletinnote;
